import React from 'react';
import { GROUP_BY_FIELD_NAMES } from '../components/forms/groupByConfigurations/groupByConstants';
import { layoutOptions, pageSizeOptions } from '../constants/reportConstants';
import { FORM_WIDGET_COMPONENTS } from '../form/formConstants';
import { FormContainer } from '../form/FormContainer';
import FormItem from '../form/FormItem';
import FormWidget from '../form/FormWidget';
import I18n from '../i18n/I18n';

export default function ReportLayoutConfigFormItems() {
    return (
        <FormContainer titleI18nToken="report.stepper.template.configure.pageconfig.title">
            <FormWidget
                component={FORM_WIDGET_COMPONENTS.radiogroup}
                name={GROUP_BY_FIELD_NAMES.pageLayout}
                align="row"
                options={layoutOptions}
            />
            <FormItem half>
                <FormWidget
                    component={FORM_WIDGET_COMPONENTS.autocomplete}
                    name={GROUP_BY_FIELD_NAMES.pageSize}
                    label={<I18n token="report.stepper.template.configure.pageconfig.pagesize" />}
                    options={pageSizeOptions}
                />
            </FormItem>
            <FormItem half>
                <FormWidget
                    component={FORM_WIDGET_COMPONENTS.number}
                    name={GROUP_BY_FIELD_NAMES.scale}
                    label={<I18n token="report.stepper.template.configure.pageconfig.scale" />}
                    forcePositive
                />
            </FormItem>
        </FormContainer>
    );
}
